<template>
  <div class="panel-body">
    <template>
      <v-card width="1000px"></v-card>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import jar from '@/components/Jar.vue'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loadingJars: false,
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    selected: [],
    jarModel: [],
    errors: [],
    jarHeaders: [
      { text: 'Put on hold', value: 'HOLD' },
      { text: 'Reactivate', value: 'ACTIVE' }
    ],
    jars: []
  }),
  created () {
    this.loadJars()
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadJars()
      }
    }
  },
  // components: {
  //     jar
  //     },
  methods: {
    async selectJar (a) {
      this.dialog = true
      this.selected = [a]
    },

    async loadJars () {
      if (
        this.user === undefined ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        // console.log('User ID not set, unable to load jars')
        this.jars = []
        return
      }
      this.loadingJars = true
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/jars/totalAmountSavedDetails?userId=${this.user.userId}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (getResponse === undefined) {
        this.jars = []
      } else {
        this.jars = getResponse.data
      }

      this.loadingJars = false
    },
    async holdJar () {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/jars/deactivates/${this.jarId}`

      var getResponse = await rh.default.delete(endpoint, true).catch(e => {
        this.errors.push(e)
      })
    },
    async reactivateJar () {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/jars/reactivate/${this.jarId}`

      var getResponse = await rh.default.delete(endpoint, true).catch(e => {
        this.errors.push(e)
      })
    }
  }
}
</script>
<style>
</style>
